export default function getInitState() {
    return {
        additionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        headerFields: [
            {
                name: "versionDate",
                label: "Dátum",
                visibility: true,
                filter:{
                    type: "simple",
                },
                slot_name: 'date_format'
            },
            {
                name: "text",
                label: "Rendszerüzenetek",
                visibility: true,
                filter:{
                    type: "simple",
                },
            },
            {
                name: "versionNumber",
                label: "Verziószám",
                visibility: true,
                filter:{
                    type: "simple",
                },
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeDashboardDetials'
            }
        ],
    }
}
